// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3JIaL","notes":"Notes_notes__3t08O"};